import { useTranslation } from 'react-i18next'
import { Modal, ConfirmationModal, Text } from '@percent/lemonade'
import { HELP_LINK } from '@percent/cause-dashboard/constants/support'

export type EditAttendanceModalProps = Readonly<{
  isOpen: boolean
  onClose: () => void
  opportunityName: string
  onSuccess?: () => void
  onError?: () => void
}>

export function EditAttendanceModal({ isOpen, onClose, opportunityName, onSuccess }: EditAttendanceModalProps) {
  const { t } = useTranslation()

  const handleOpenSupportForm = () => {
    const windowRef = window.open(HELP_LINK, '_blank', 'noopener,noreferrer')

    if (windowRef) {
      onSuccess?.()
    }

    onClose()
  }

  return (
    <Modal open={isOpen} onClose={onClose}>
      <ConfirmationModal
        title={t('volunteering.actionsMenu.editAttendanceModal.title')}
        primaryButtonText={t('volunteering.actionsMenu.editAttendanceModal.supportFormButton')}
        secondaryButtonText={t('button.cancel')}
        handleClose={onClose}
        handleSubmit={handleOpenSupportForm}
        primaryBtnTestId="edit-attendance-support-form-button"
        secondaryBtnTestId="edit-attendance-cancel-button"
        buttonShape="default"
      >
        <Text size="small">{t('volunteering.actionsMenu.editAttendanceModal.description', { opportunityName })}</Text>
      </ConfirmationModal>
    </Modal>
  )
}
